// @flow

import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { breakpointsToArray } from '../../../helpers';
import { Flex, Box } from '../../grid';
import { isLoading, hasError, getErrorResponse } from '../../../store/configuration/configForm/selectors';
import { getNotSend } from '../../../store/formSettings/selectors';
import type { Theme } from '../../../types';

const ErrorBar = styled<any, Theme>('section')`
  background-color: ${props => props.theme.form.submitBarError.backgroundColor};
  border-radius: ${props => props.theme.form.submitBarError.borderRadius};
  color: ${props => props.theme.form.submitBarError.color};
  margin-bottom: 1rem;
  padding: 1rem;
`;

type OwnProps = {|
  children: Function,
|};

type StateProps = {|
  saving: boolean,
  error: boolean,
  errorResponse: {
    code?: number,
    message?: string,
    data?: {
      status: number,
    },
  },
  defaultError: string,
|};

// Props also contains "rest props" which are the ACF
type Props = StateProps & OwnProps;

const SubmitBar = ({
  defaultError,
  error,
  saving,
  errorResponse,
  children,
}: Props) => {
  let errMessage = defaultError;

  if (errorResponse.code === 400 && errorResponse.message !== '') {
    errMessage = errorResponse.message;
  }

  return (
    <div>
      {error && !saving && (
        <ErrorBar>{errMessage}</ErrorBar>
      )}
      <Flex width={breakpointsToArray({ default: 1 })}>
        <Box>{children(saving)}</Box>
      </Flex>
    </div>
  );
};

const mapStateToProps = (state): StateProps => ({
  saving: isLoading(state),
  error: hasError(state),
  errorResponse: getErrorResponse(state),
  defaultError: getNotSend(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(SubmitBar);
